var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe",style:({ height: _vm.maxHeight + 'px', width: _vm.maxWidth + 'px' }),attrs:{"src":_vm.iframe_uri}})
}
var staticRenderFns = []

export { render, staticRenderFns }